import { combineReducers } from '@reduxjs/toolkit';
import GeneralReducer from './general';
import MessageBoardReducer from './messageBoard';
import templatesReducer from './templates';

const rootReducer = combineReducers({
  general: GeneralReducer,
  messageBoard: MessageBoardReducer,
  templates: templatesReducer,
});

export default rootReducer;
